/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-underscore-dangle */
import { Container, Box, Typography } from '@mui/material';

const SecurePayment = () => {
  return (
    <Container sx={{ px: 0, pb: 4 }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mt: 6, mb: 2 }}>
        Secure Payment
      </Typography>
      <Box
        sx={{
          px: 3,
          py: 3,
          backgroundColor: '#f5f5f5',
          borderRadius: 2,
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          maxWidth: 1000,
          mx: 'auto',
          color: '#444',
          fontSize: '0.95rem',
          lineHeight: 1.8,
          textAlign: 'left',
        }}
      >
        <Typography fontWeight="bold" gutterBottom>
          Our secure payment
        </Typography>
        <Typography paragraph>With SSL</Typography>

        <Typography fontWeight="bold" gutterBottom>
          Using Visa/Mastercard/AMEX/Discover/Paypal
        </Typography>
      </Box>
    </Container>
  );
};

export default SecurePayment;
